import { LitElement, html } from 'lit-all'

class ASVariantCardActions extends LitElement {
  static get properties() {
    return {
      pageType: { type: String },
      config: { type: Object },
      showAddToCart: { type: Boolean },
      variant: { type: Object, attribute: 'variant' },
      complementaryProducts: { type: Boolean },
      shopEmail: { type: String }
    };
  }

  constructor() {
    super();
  }
  
  createRenderRoot() {
    return this;
  }

  get quickBuyClasses() {
    if (this.isListGridView || this.showAddToCart) {
      return this.complementaryProducts
        ? 'product-item__action-button button button--small button--ternary'
        : 'product-item__action-button button button--small button--primary';
    }
    
    return 'product-item__action-button product-item__action-button--list-view-only button button--small button--primary';
  }

  render() {
    const formId = `product_form_id_${this.variant.id}`;
    
    const isListGridView = this.config.showQuickView === 'list_grid' || this.config.showQuickBuy === 'list_grid';
    
    const productFormClasses = isListGridView || this.showAddToCart 
      ? 'product-item__action-list button-stack'
      : 'product-item__action-list product-item__action-list--list-view-only button-stack';
  
    const quickViewClasses = this.config.showQuickView === 'list_grid'
      ? 'product-item__action-button button button--small button--ternary hidden-phone'
      : 'product-item__action-button product-item__action-button--list-view-only button button--small button--ternary hidden-phone';

    return html`
      <form id="${formId}" class="${productFormClasses}" action="/cart/add">
        <input type="hidden" name="quantity" value="1">
        <input type="hidden" name="id" value="${this.variant.id}">
        
        ${this.variant.availableForSale ? html`
          <button type="submit" class="${this.quickBuyClasses}" data-action="add-to-cart">
            ${this.variant.template_suffix === 'pre-order' ? 'Pre-Order' : 'Add to Cart'}
          </button>
        ` : html`
          <button class="${this.quickBuyClasses.replace('button--primary', 'button--disabled')}" disabled>Sold Out</button>
        `}

        <button type="button" class="${quickViewClasses}" data-action="open-modal" data-secondary-action="open-quick-view">
          Quick View
        </button>
      </form>
    `
  }
}

customElements.define('as-variant-card-actions', ASVariantCardActions);
